import { Record } from "immutable";
import moment from "moment";

const defaults = {
    id: undefined,
    brand_id: undefined,
    payment_account_id: undefined,
    currency_code: undefined,
    display_name: undefined,
    start_date: undefined,
    end_date: undefined,
    created_on: undefined,
    modified_on: undefined,
};

export class Statement extends Record(defaults) {
    declare id: string;
    declare brand_id: string;
    declare payment_account_id: string;
    declare currency_code: string;
    declare display_name: string;
    declare start_date: moment.Moment;
    declare end_date: moment.Moment;
    declare created_on: moment.Moment;
    declare modified_on: moment.Moment;

    constructor(args) {
        super({
            ...args,
            created_on: moment.utc(args.created_on),
            modified_on: moment.utc(args.modified_on),
            start_date: moment.utc(args.start_date),
            end_date: moment.utc(args.end_date),
        });
    }
}
